import { render, staticRenderFns } from "./BehaviorPage.vue?vue&type=template&id=57eeb4fa&scoped=true&"
import script from "./BehaviorPage.vue?vue&type=script&lang=js&"
export * from "./BehaviorPage.vue?vue&type=script&lang=js&"
import style0 from "./BehaviorPage.vue?vue&type=style&index=0&id=57eeb4fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57eeb4fa",
  null
  
)

export default component.exports